import $ from 'jquery';

App.registerBehavior('SurveyCompletePage', function (appSettings, settingsKey) {
  document.addEventListener('click', function (event) {
    if (event) {
      const bypassList = ['dialog', 'accordion'];
      const $element = $(event.target);
      const $link = $element.is('a') && $element || $element.parent().is('a') && $element.parent();
      const link_exists = 0 < $link.length;
      const settings = 'undefined' !== typeof appSettings[settingsKey] && appSettings[settingsKey] || {};
      const survey_cancel_url = 'string' === typeof settings.survey_cancel_url && settings.survey_cancel_url || '';
      if (true === link_exists && !bypassList.includes($element.attr('data-bypass')) && !bypassList.includes($element.parent().attr('data-bypass'))) {
        const surveyCompletePage = $('[data-dialog]');
        const type = 'string' === typeof surveyCompletePage.data('dialog') && surveyCompletePage.data('dialog') || '';
        const message = 'string' === typeof surveyCompletePage.data('dialog-msg') && surveyCompletePage.data('dialog-msg') || '';
        if (0 < survey_cancel_url.length) {
          $link.attr('href', survey_cancel_url + '?destination=' + encodeURIComponent($link.attr('href')));
        }
        return Dialog.factory(type, message, event);
      }
    }
  });
}, Util.lastOf(document.getElementsByTagName('script')).src);
